import { IFieldType, IFormSchema } from "shared/types";
import { copy } from "shared/assets";

const { stageProperties, errors } = copy;

export const formData: IFormSchema = {
  fields: [
    {
      type: IFieldType.text,
      name: "title",
      label: stageProperties.title.title,
      validation: {
        required: errors.required,
      },
    },
    {
      type: IFieldType.rte,
      name: "info",
      label: stageProperties.info.title,
    },
  ],
};

export const lightFormData: IFormSchema = {
  fields: [
    {
      type: IFieldType.text,
      name: "title",
      label: stageProperties.title.title,
      validation: {
        required: errors.required,
      },
    },
  ],
};
